<script setup lang="ts">
import { computed } from 'vue'

import { ColorPicker } from '@/ui'

const DEFAULT_COLOR = '#262626'

const props = withDefaults(
  defineProps<{
    modelValue?: string
    highlight?: boolean
    disabled?: boolean
  }>(),
  {
    modelValue: '',
    highlight: false,
    disabled: false,
  }
)

const emit = defineEmits<{
  (event: 'update:modelValue', color: string | undefined): void
  (event: 'change', color: string | undefined): void
}>()

const currentColor = computed({
  get: () => props.modelValue || DEFAULT_COLOR,
  set: (val: string) => {
    emit('update:modelValue', val)
    emit('change', val)
  },
})
</script>

<template>
  <ColorPicker
    :id="highlight ? 'EditorHighlight' : 'EditorText'"
    v-model="currentColor"
    :disabled="disabled"
    :default-color="highlight ? undefined : DEFAULT_COLOR"
  >
    <slot />
  </ColorPicker>
</template>
